var __typeError = (msg) => {
  throw TypeError(msg);
};
var __accessCheck = (obj, member, msg) => member.has(obj) || __typeError("Cannot " + msg);
var __privateGet = (obj, member, getter) => (__accessCheck(obj, member, "read from private field"), getter ? getter.call(obj) : member.get(obj));
var __privateAdd = (obj, member, value) => member.has(obj) ? __typeError("Cannot add the same private member more than once") : member instanceof WeakSet ? member.add(obj) : member.set(obj, value);
var __privateSet = (obj, member, value, setter) => (__accessCheck(obj, member, "write to private field"), setter ? setter.call(obj, value) : member.set(obj, value), value);
var __privateMethod = (obj, member, method) => (__accessCheck(obj, member, "access private method"), method);
var _cache, _currentHandle, _QuickViewDialog_instances, loadProduct_fn, renderContent_fn, showLoadingSkeleton_fn, hideLoadingSkeleton_fn;
import { C as CustomDialog } from "./custom-dialog-MTSjyveX.js";
import { K as setInnerHTML, t as lazyReveal, q as activateInteractionAssets } from "./utilities-Da0sjanJ.js";
class QuickViewDialog extends CustomDialog {
  constructor() {
    super(...arguments);
    __privateAdd(this, _QuickViewDialog_instances);
    /** @type {Map<string, string>} Cache of product HTML by handle */
    __privateAdd(this, _cache, /* @__PURE__ */ new Map());
    /** @type {string|null} Currently loaded product handle */
    __privateAdd(this, _currentHandle, null);
  }
  get contentEl() {
    return this.querySelector('[ref="quickViewContent"]');
  }
  get loadingSkeletonEl() {
    return this.querySelector('[ref="quickViewLoadingSkeleton"]');
  }
  /**
   * Open the dialog for a specific product handle.
   * @param {string} productHandle
   */
  async showDialogForProduct(productHandle) {
    __privateMethod(this, _QuickViewDialog_instances, showLoadingSkeleton_fn).call(this);
    await Promise.all([
      this.showDialog(),
      __privateMethod(this, _QuickViewDialog_instances, loadProduct_fn).call(this, productHandle)
    ]);
    __privateMethod(this, _QuickViewDialog_instances, hideLoadingSkeleton_fn).call(this);
  }
}
_cache = new WeakMap();
_currentHandle = new WeakMap();
_QuickViewDialog_instances = new WeakSet();
loadProduct_fn = async function(productHandle) {
  if (__privateGet(this, _currentHandle) === productHandle && __privateGet(this, _cache).has(productHandle)) {
    return;
  }
  if (__privateGet(this, _cache).has(productHandle)) {
    __privateMethod(this, _QuickViewDialog_instances, renderContent_fn).call(this, __privateGet(this, _cache).get(productHandle));
    __privateSet(this, _currentHandle, productHandle);
    return;
  }
  try {
    const response = await fetch(
      `/products/${productHandle}?view=modal&sections=sc_main_product_quick_view`
    );
    const data = await response.json();
    const parsed = new DOMParser().parseFromString(
      data["sc_main_product_quick_view"],
      "text/html"
    );
    const innerQuickView = parsed.querySelector(".sc-main-quick-view");
    const html = innerQuickView ? innerQuickView.outerHTML : data["sc_main_product_quick_view"];
    __privateGet(this, _cache).set(productHandle, html);
    __privateSet(this, _currentHandle, productHandle);
    __privateMethod(this, _QuickViewDialog_instances, renderContent_fn).call(this, html);
  } catch (error) {
    if (this.contentEl) {
      this.contentEl.innerHTML = '<div class="error">Failed to load product</div>';
    }
  }
};
/**
 * Render HTML content into the content container.
 * @param {string} html
 */
renderContent_fn = function(html) {
  const content = this.contentEl;
  if (!content) return;
  setInnerHTML(content, html);
  lazyReveal(content);
  activateInteractionAssets(content);
  content.classList.add("content-loaded");
  __privateMethod(this, _QuickViewDialog_instances, hideLoadingSkeleton_fn).call(this);
};
showLoadingSkeleton_fn = function() {
  var _a;
  const content = this.contentEl;
  if (content) {
    content.classList.remove("content-loaded");
  }
  (_a = this.loadingSkeletonEl) == null ? void 0 : _a.classList.add("loading-skeleton-visible");
};
hideLoadingSkeleton_fn = function() {
  var _a;
  (_a = this.loadingSkeletonEl) == null ? void 0 : _a.classList.remove("loading-skeleton-visible");
};
if (!customElements.get("quick-view-dialog")) {
  customElements.define("quick-view-dialog", QuickViewDialog);
}
